function setCardPreview(card, src, srcset) {
  const media = card.querySelector('.media.media--hover-effect') || card.querySelector('.card__media .media');
  if (!media) return;
  const imgs = media.querySelectorAll('img');
  if (!imgs.length) return;

  if (!card.dataset.originalSrc) {
    const primary = imgs[0];
    card.dataset.originalSrc = primary.getAttribute('src') || '';
    card.dataset.originalSrcset = primary.getAttribute('srcset') || '';
    if (imgs[1]) {
      card.dataset.originalSecondSrc = imgs[1].getAttribute('src') || '';
      card.dataset.originalSecondSrcset = imgs[1].getAttribute('srcset') || '';
    }
    // store original product URL once
    const firstLink = card.querySelector('.card__heading a.full-unstyled-link');
    if (firstLink && !card.dataset.originalProductUrl) {
      card.dataset.originalProductUrl = firstLink.getAttribute('href') || '';
    }
  }

  imgs.forEach((img) => {
    if (src) img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
  });
  card.classList.add('swatch-preview-active');
}

function updateCardLinks(card, url) {
  const anchors = card.querySelectorAll('.card__heading a.full-unstyled-link');
  anchors.forEach((a) => {
    if (url) a.setAttribute('href', url);
    else if (card.dataset.originalProductUrl) a.setAttribute('href', card.dataset.originalProductUrl);
  });
}

function applyLockedPreview(card) {
  if (card.dataset.lockedPreview === '1') {
    const src = card.dataset.lockedSrc || '';
    const srcset = card.dataset.lockedSrcset || '';
    if (src) setCardPreview(card, src, srcset);
    if (card.dataset.lockedUrl) updateCardLinks(card, card.dataset.lockedUrl);
    return true;
  }
  return false;
}

function lockCardPreview(card, src, srcset, swatchEl, url) {
  card.dataset.lockedPreview = '1';
  card.dataset.lockedSrc = src || '';
  card.dataset.lockedSrcset = srcset || '';
  if (url) card.dataset.lockedUrl = url;
  if (!card.dataset.originalProductUrl) {
    const firstLink = card.querySelector('.card__heading a.full-unstyled-link');
    if (firstLink) card.dataset.originalProductUrl = firstLink.getAttribute('href') || '';
  }
  if (url) updateCardLinks(card, url);
  // mark active swatch
  const group = card.querySelectorAll('.card-swatch');
  group.forEach((el) => el.classList.remove('card-swatch--active'));
  if (swatchEl) swatchEl.classList.add('card-swatch--active');
  // voorkom dubbele tooltip door focus weg te nemen na klik
  if (swatchEl && typeof swatchEl.blur === 'function') {
    swatchEl.blur();
  }
}

function unlockCardPreview(card) {
  delete card.dataset.lockedPreview;
  delete card.dataset.lockedSrc;
  delete card.dataset.lockedSrcset;
  delete card.dataset.lockedUrl;
  const group = card.querySelectorAll('.card-swatch');
  group.forEach((el) => el.classList.remove('card-swatch--active'));
  // restore to original immediately
  const container = card.querySelector('.card-swatches');
  restoreCardImage(container);
  updateCardLinks(card, null);
}

document.addEventListener('mouseover', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;
  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const newSrc = swatch.getAttribute('data-image');
  const newSrcset = swatch.getAttribute('data-srcset') || '';
  setCardPreview(card, newSrc, newSrcset);
});

function restoreCardImage(container) {
  if (!container) return;
  const card = container.closest('.card-wrapper');
  if (!card || !card.dataset.originalSrc) return;
  const media = card.querySelector('.media.media--hover-effect') || card.querySelector('.card__media .media');
  if (!media) return;
  const imgs = media.querySelectorAll('img');
  if (!imgs.length) return;
  // if locked, keep locked preview active
  if (applyLockedPreview(card)) return;

  const originalSrc = card.dataset.originalSrc || '';
  const originalSrcset = card.dataset.originalSrcset || '';
  const originalSecondSrc = card.dataset.originalSecondSrc || '';
  const originalSecondSrcset = card.dataset.originalSecondSrcset || '';

  if (imgs[0]) {
    imgs[0].setAttribute('src', originalSrc);
    if (originalSrcset) imgs[0].setAttribute('srcset', originalSrcset);
    else imgs[0].removeAttribute('srcset');
  }
  if (imgs[1]) {
    if (originalSecondSrc) imgs[1].setAttribute('src', originalSecondSrc);
    if (originalSecondSrcset) imgs[1].setAttribute('srcset', originalSecondSrcset);
    else imgs[1].removeAttribute('srcset');
  }
  card.classList.remove('swatch-preview-active');
}

document.addEventListener('mouseout', function (e) {
  const container = e.target.closest('.card-swatches');
  if (!container) return;
  const related = e.relatedTarget;
  if (related && container.contains(related)) return;
  restoreCardImage(container);
});

document.addEventListener('blur', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;
  const container = swatch.closest('.card-swatches');
  restoreCardImage(container);
}, true);

// Persistent preview on click (for touch devices)
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;
  const card = swatch.closest('.card-wrapper');
  if (!card) return;
  const newSrc = swatch.getAttribute('data-image');
  const newSrcset = swatch.getAttribute('data-srcset') || '';
  const variantUrl = swatch.getAttribute('data-variant-url') || '';
  // toggle lock if clicking active swatch
  if (swatch.classList.contains('card-swatch--active')) {
    unlockCardPreview(card);
    return;
  }
  setCardPreview(card, newSrc, newSrcset);
  lockCardPreview(card, newSrc, newSrcset, swatch, variantUrl);
});

// Restore when leaving card area entirely
document.addEventListener('mouseleave', function (e) {
  const card = e.target.closest && e.target.closest('.card-wrapper');
  if (!card) return;
  const container = card.querySelector('.card-swatches');
  restoreCardImage(container);
}, true);


